const isConfigDefined = () =>
  typeof window !== 'undefined' && window.ADV_SHOPFRONT_CONFIG;

export default isConfigDefined;
